export const useDialog = ({ formSetterName = 'setForm' } = {}) => ({
  model: {
    type: 'input',
    prop: 'value',
  },
  props: {
    value: Boolean,
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    submitBtnName() {
      return this.creator ? 'Create' : 'Save';
    },
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue && this[formSetterName]) {
          this[formSetterName]();
        }
      },
      immediate: true,
    },
  },
});

export const useEditorWithDialog = ({
  editableItemName = 'editableItem',
  openTriggerName = 'openEditorDialog',
  editorModeFlagName = 'isEditorCreateMode',
  editorDialogFlagName = 'editorDialog',
  editableItemDefaultValue = {},
} = {}) => ({
  data: () => ({
    [editableItemName]: editableItemDefaultValue,
    [editorDialogFlagName]: false,
    [editorModeFlagName]: true,
  }),
  methods: {
    [openTriggerName](data) {
      if (data) {
        this.$set(this, editableItemName, data);
      }
      this[editorModeFlagName] = !data;
      this[editorDialogFlagName] = true;
    },
  },
});
